module.exports = __webpack_public_path__ + "img/bg-waves.458d9f3e.png";